import { render } from "./Button.vue?vue&type=template&id=73ea6a74&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import "./Button.vue?vue&type=style&index=0&id=73ea6a74&lang=scss&scoped=true"

import exportComponent from "/proyectos/servicios/ide-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73ea6a74"]])

export default __exports__